import { Breadcrumbs } from "@amzn/stencil-react-components/breadcrumbs";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Link, LinkIconPosition } from "@amzn/stencil-react-components/link";
import { H1 } from "@amzn/stencil-react-components/text";
import IconExternalLink from "@amzn/stencil-react-icons/icons/icon-external-link";
import React, { FC } from "react";
import { useCrumbClick } from "@/common/hooks/use-crumb-click";
import { Paths } from "@/common/paths/paths";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import { IT_SHOP_URL } from "@/config";
import { IT_PORTAL_URL } from "@/common/constants/external-links.constants";

interface OrderTrackingHeaderProps {
  orderNumber: string;
}

export const OrderTrackingHeader: FC<OrderTrackingHeaderProps> = ({ orderNumber }) => {
  const onCrumbClick = useCrumbClick();

  return (
    <Col gridGap="S400" width="100%">
      <Breadcrumbs
        crumbs={[
          { title: getString("orderTracking.crumbs.itShop"), url: IT_SHOP_URL },
          { title: getString("orderTracking.crumbs.yourOrders"), url: Paths.orders.url },
          { title: orderNumber },
        ]}
        onCrumbClick={onCrumbClick}
      />
      <Row justifyContent="space-between" alignItems="center" gridGap="S300">
        <H1>{getString("orderTracking.title", { orderNumber })}</H1>
        <Link
          href={IT_PORTAL_URL}
          target="_blank"
          icon={<IconExternalLink aria-hidden={true} />}
          iconPosition={LinkIconPosition.Trailing}
        >
          {getString("orderTracking.supportLink")}
        </Link>
      </Row>
    </Col>
  );
};
